import useFetch from 'hooks/useFetch'
const endPoint = '/auth'
const getAuthUrl = (path) => process.env.REACT_APP_BASE_URL.replace(/\/api$/, '') + endPoint + path;

export const LoginApi = async (router, _data) => {
	let response = await useFetch(router).post(getAuthUrl('/login'), {
		email: _data.email,
		password: _data.password
	})

	return response
}

export const ChangePasswordApi = async (router, _data) => {
	let response = await useFetch(router, true).put(
		getAuthUrl('/changePassword'),
		_data
	)

	return response
}

export const ResetPasswordApi = async (router, _data) => {
	let response = await useFetch(router).post(getAuthUrl('/resetPassword'), _data)

	return response
}
export const SendEmailForResetPasswordApi = async (router, _email) => {
	let response = await useFetch(router).post(getAuthUrl('/forgetPassword'), {
		email: _email
	})

	return response
}

export const GetUserData = async (router, token, project_id) => {
	const url = project_id === 0 ? getAuthUrl('') : getAuthUrl(`?project_id=${project_id}`);
	let response = await useFetch(router).get(url,{ headers: {"Authorization" : `Bearer ${token}`} });
	return response;
}
